import React from 'react'
import ReactDOM from 'react-dom'
import { AppContainer } from 'react-hot-loader'

// Shim for IE
if(!String.prototype.normalize){
	String.prototype.normalize = function(){
		return this
	}
}

document.addEventListener('DOMContentLoaded', () => {
	renderComponent()
})

if(module.hot)	module.hot.accept('./containers/Core', () => renderComponent())

function renderComponent(){
	const Router = require('./containers/Core').default
	return ReactDOM.render(
		<AppContainer>
			<Router />
		</AppContainer>,
		document.getElementById('root')
	)
}



// WEBPACK FOOTER //
// ./client/render.js